var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('canvas',{attrs:{"id":"qrCodeCanvas"}}),_c('div',{staticClass:"u-break-word"},[_vm._v("\n        "+_vm._s(_vm.link)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }